import { useEffect } from 'react';

export default function useFocusRefOnKeyPress(inputRef) {
  useEffect(() => {
    const handleKeyDown = nativeEvent => {
      if (nativeEvent.defaultPrevented) {
        return;
      }

      if (
        nativeEvent.key === 'Escape' &&
        document.activeElement === inputRef.current
      ) {
        inputRef.current.blur();
        return;
      }

      const matchMainShortcut =
        (nativeEvent.ctrlKey || nativeEvent.metaKey) && nativeEvent.key === 'k';
      const matchOtherShortcuts = ['/', 's'].indexOf(nativeEvent.key) !== -1;

      const matchNonkeyboardNode = !['INPUT', 'SELECT', 'TEXTAREA'].includes(
        document.activeElement.tagName,
      );

      if ((matchMainShortcut || matchOtherShortcuts) && matchNonkeyboardNode) {
        nativeEvent.preventDefault();
        inputRef.current.focus();
        inputRef.current.select();
      }

      if (matchMainShortcut && document.activeElement === inputRef.current) {
        nativeEvent.preventDefault();
        inputRef.current.select();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [inputRef]);
}
